<template>
  <div class="product-page__row row">
    <div class="col-lg-10">
      <span class="product-page__row-subTitle mb-xl-3 mb-4" v-if="selects.length">Select material</span>

      <label v-for="select in selects" :key="select.id"
             class="product-page__material"
             @click.prevent="selectOption(select)"
      >
        <input class="card-input-element"
               type="radio" name="product"
               :checked="select.id === selected.id">
        <div class="panel panel-default card-input product-page__material-card">
          <div class="product-page__material-card-img"
               :style="`background-image: url(/assets/img/product-page-img-material-${select.id}.jpg)`">
            <div class="product-page__material-radio">
              <i class="product-page__material-radioIcon"></i><span>Selected</span>
            </div>
          </div>
          <div class="product-page__material-card-body">
            <span class="product-page__material-card-body-title">{{select.title.ru}}</span>
            <div class="product-page__material-card-body-text">{{select.pivot.description}}</div>
            <p class="product-page__material-card-body-num" v-show="select.id !== selected.id">
              {{selected.pivot.price > select.pivot.price ? '-' : '+'}}
              {{Math.abs(selected.pivot.price - select.pivot.price).toLocaleString()}} UAH
            </p>
          </div>
        </div>
      </label>
    </div>
    <div class="col-lg-2">
      <div class="product-page-social">
        <a class="product-page-social__item" href="#">
          <span class="pinterest-icon-product"></span>
        </a>
        <a class="product-page-social__item" href="#">
          <span class="inst-icon-product"></span>
        </a>
        <a class="product-page-social__item" href="#">
          <span class="facebook-icon-product"></span>
        </a>
        <a class="product-page-social__item" href="#">
          <span class="twitter-icon-product"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ProductOrderSelects',
  computed: {
    ...mapGetters('shop_card', ['item', 'selects', 'selected']),
  },
  methods: {
    ...mapMutations('shop_card', ['setSelected']),
    selectOption (item) {
      this.setSelected(item)
    },
  },
}
</script>

<style scoped>

</style>
